import { Box, Button, createStyles, Modal, Text } from "@mantine/core";
import React from "react";

const useStyles = createStyles((theme) => ({
  flexend: {
    display: "flex",
    // justifyContent:'space-between',
    gap: "50px",
  },

  container: {
    // maxWidth: "300px",
    margin: "20px auto",
    border: "2px solid #ddd",
    borderRadius: "8px",
    overflow: "scroll",
    padding: "20px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    padding: "12px",
    textAlign: "left",
    backgroundColor: "#333",
    color: "white",
    fontWeight: "bold",
  },
  td: {
    padding: "12px",
    textAlign: "left",
    borderBottom: "1px solid #ddd",
  },
  amountColumn: {
    textAlign: "right",
  },
  totalRow: {
    backgroundColor: "#f9f9f9",
  },
  totalLabel: {
    fontWeight: "bold",
  },
  totalAmount: {
    fontWeight: "bold",
    textAlign: "right",
  },
}));

const ViewPayment = ({ row, isPreview, setIsPreview }) => {
  const { classes, cx } = useStyles();

  const handleClose = () => {
    setIsPreview(false);

  };

  function numberToEnglish(n) {
    var string = n.toString(),
      units,
      tens,
      scales,
      start,
      end,
      chunks,
      chunksLen,
      chunk,
      ints,
      i,
      word,
      words,
      and = "and";

    /* Remove spaces and commas */
    string = string.replace(/[, ]/g, "");

    /* Is number zero? */
    if (parseInt(string) === 0) {
      return "zero";
    }

    /* Array of units as words */
    units = [
      "",
      "one",
      "two",
      "three",
      "four",
      "five",
      "six",
      "seven",
      "eight",
      "nine",
      "ten",
      "eleven",
      "twelve",
      "thirteen",
      "fourteen",
      "fifteen",
      "sixteen",
      "seventeen",
      "eighteen",
      "nineteen",
    ];

    /* Array of tens as words */
    tens = [
      "",
      "",
      "twenty",
      "thirty",
      "forty",
      "fifty",
      "sixty",
      "seventy",
      "eighty",
      "ninety",
    ];

    /* Array of scales as words */
    scales = [
      "",
      "thousand",
      "million",
      "billion",
      "trillion",
      "quadrillion",
      "quintillion",
      "sextillion",
      "septillion",
      "octillion",
      "nonillion",
      "decillion",
      "undecillion",
      "duodecillion",
      "tredecillion",
      "quatttuor-decillion",
      "quindecillion",
      "sexdecillion",
      "septen-decillion",
      "octodecillion",
      "novemdecillion",
      "vigintillion",
      "centillion",
    ];

    /* Split user argument into 3 digit chunks from right to left */
    start = string.length;
    chunks = [];
    while (start > 0) {
      end = start;
      chunks.push(string.slice((start = Math.max(0, start - 3)), end));
    }

    /* Check if function has enough scale words to be able to stringify the user argument */
    chunksLen = chunks.length;
    if (chunksLen > scales.length) {
      return "";
    }

    /* Stringify each integer in each chunk */
    words = [];
    for (i = 0; i < chunksLen; i++) {
      chunk = parseInt(chunks[i]);

      if (chunk) {
        /* Split chunk into array of individual integers */
        ints = chunks[i].split("").reverse().map(parseFloat);

        /* If tens integer is 1, i.e. 10, then add 10 to units integer */
        if (ints[1] === 1) {
          ints[0] += 10;
        }

        /* Add scale word if chunk is not zero and array item exists */
        if ((word = scales[i])) {
          words.push(word);
        }

        /* Add unit word if array item exists */
        if ((word = units[ints[0]])) {
          words.push(word);
        }

        /* Add tens word if array item exists */
        if ((word = tens[ints[1]])) {
          words.push(word);
        }

        /* Add 'and' string after units or tens integer if: */
        if (ints[0] || ints[1]) {
          /* Chunk has a hundreds integer or chunk is the first of multiple chunks */
          if (ints[2] || (!i && chunksLen)) {
            words.push(and);
          }
        }

        /* Add hundreds word if array item exists */
        if ((word = units[ints[2]])) {
          words.push(word + " hundred");
        }
      }
    }

    return words.reverse().join(" ");
  }



  return (
    <>
      <Modal
        opened={isPreview}
        size={1000}
        title="View Invoice"
        shadow="md"
        onClose={handleClose}
        overlayProps={{ blur: 3 }}
        radius={"lg"}
        zIndex={1000}
        centered
      >
        <Box>
          <Text
            style={{ marginTop: "20px", textAlign: "center" }}
            fs={36}
            fw={900}
            color="#171717"
          >
            Payment Receipt
          </Text>

          <Box className={classes.flexend}>
            <Box fs={26} fw={700} color="#171717">
              Payment Date :
            </Box>
            <Box fs={20} fw={500} color="#000">
              {row?.createdAt
                ? new Date(row?.createdAt).toLocaleDateString("en-GB")
                : "Date Not Available"}
            </Box>
          </Box>

          <Box className={classes.flexend}>
            <Box fs={26} fw={700} color="#171717">
              Payment Mode :
            </Box>
            <Box fs={20} fw={500} color="#000">
              Stripe
            </Box>
          </Box>

          <Box className={classes.flexend}>
            <Box fs={26} fw={700} color="#171717">
              Amount Received in words :
            </Box>
            <Box fs={20} fw={500} color="#000">
              {row?.invoiceId?.totalAmount
                ? `${numberToEnglish(row?.invoiceId?.totalAmount)} USD Only`
                : ""}
            </Box>
          </Box>

          <Box style={{ marginTop: "20px", marginBottom: "20px" }}>
            <Text fs={26} fw={700} color="#171717">
              Payment For
            </Text>
          </Box>
          <div className={classes.container}>
            <table className={classes.table}>
              <thead>
                <tr>
                  <th className={classes.th}>Item</th>
                  <th className={classes.th}>Quantity</th>
                  <th className={classes.th}>Amount</th>
                </tr>
              </thead>
              <tbody>
                {row?.invoiceId?.interventionDetails?.map((item, index) => (
                  <tr key={index}>
                    <td className={classes.td}>{item.name}</td>
                    <td className={classes.td}>{item.quantity}</td>
                    <td className={{ ...classes.td, ...classes.amountColumn }}>
                      {item.amount.toLocaleString("en-IN", {
                        className: "currency",
                        currency: "USD",
                      })}
                    </td>
                  </tr>
                ))}
                <tr className={classes.totalRow}>
                  <td className={{ ...classes.td, ...classes.totalLabel }}>
                    Total
                  </td>
                  <td
                    className={{
                      ...classes.td,
                      ...classes.amountColumn,
                      ...classes.totalAmount,
                    }}
                  >
                    {row?.invoiceId?.totalAmount.toLocaleString("en-IN", {
                      style: "currency",
                      currency: "USD",
                    })}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

  <Box
                  style={{ marginTop: "20px", marginBottom: "20px" }}
                  className={classes.dflex}
                >
                  <Button
                    variant="filled"
                    onClick={handleClose}
                    c={"#000"}
                    style={{ width: "40%",margin:'auto',display:'flex',justifyContent:'center' }}
                    // className={classes.backNextBtn}
                    color="yellow"
                    size="md"
                  >
                 Cancel
                  </Button>
                  </Box>


        </Box>



      </Modal>
    </>
  );
};

export default ViewPayment;
